import Farm from "@/farm/Farm"
import Cheat from "@/Cheat"

export default class Cheatmode {
  private _farm: Farm
  private cheats: Cheat[] = [
    new Cheat("addMoney",
      `(amount): Gives you money. 'amount' is how much.`,
      (farm, amount) => {
        farm.state.money += amount
        return `Added $${amount}`
      }),
    new Cheat("addMilk",
      `(amount): Gives you milk. 'amount' is how many litres.`,
      (farm, amount) => {
        farm.state.milk.addValue(amount)
        return `Added ${amount}L`
      }),
    new Cheat("gameSpeed",
      `(speed): Sets the game speed. 'speed' is a number.`,
      (farm, speed) => {
        farm.state.timeDilationFactor = speed / 2
        return `Game speed set to ${speed}x`
      }),
    new Cheat("debugLab",
      `(true|false): Sets debug mode for lab to true or false. If true grants automatic science gain.`,
      (farm, boolean) => {
        farm.state.lab.debug = boolean
        return `Lab debug mode: ${boolean}`
      }),
    new Cheat("triggerEvent",
      `(choice): Triggers a specific event. 'choice' is a number representing the event.`,
      (farm, choice) => {
        farm.state.eventManager.addEvent(farm.state.eventManager.randomEvent(farm, choice), farm)
        return "Event triggered"
      })
  ]
  private activated: boolean = false

  constructor(farm: Farm) {
    this._farm = farm
    // @ts-ignore
    window.cheatmode = (password: string) => { return this.activateCheats(password) }
  }

  set farm(farm: Farm) {
    this._farm = farm
    this.registerCheats()
  }

  activateCheats(password: string): string {
    if (password != "strawberry") return "Wrong password. Find out the current password by becoming a Patreon supporter!"
    this.activated = true
    this.registerCheats()

    let s = "Cheatmode activated. Available commands: \n\n"
    for (let cheat of this.cheats) {
      s += `${cheat.name}${cheat.description}\n`
    }
    return s
  }

  private registerCheats() {
    if (!this.activated) return false

    for (let cheat of this.cheats) {
      cheat.activate(this._farm)
    }
  }
}
